/**
 * MirO Stash — garde la banniere "livraison gratuite / paliers de quantite"
 * (snippets/free-shipping-progress.liquid) synchronisee avec le contenu reel
 * du panier, meme quand un ajout au panier passe par un mecanisme qui ne
 * rafraichit pas cette banniere lui-meme (ex. le bouton « Ajouter au panier »
 * de l'atelier 3D / du configurateur, qui gere son propre ajout au panier
 * en dehors du formulaire natif du theme).
 *
 * Principe : quelle que soit l'origine du clic, un ajout ou une
 * modification de panier finit toujours par un appel reseau vers l'API
 * Ajax Cart de Shopify (/cart/add(.js), /cart/change(.js),
 * /cart/update(.js), /cart/clear(.js)). On intercepte donc les deux façons
 * standard de faire cet appel (fetch et XMLHttpRequest) au niveau global :
 * des qu'un de ces appels se termine, on va chercher le rendu a jour de la
 * section "cart-drawer" (qui contient deja cette meme banniere, toujours
 * recalculee cote serveur a partir du panier courant) et on recopie son
 * contenu dans toutes les bannieres presentes sur la page (page produit,
 * tiroir panier, page panier).
 *
 * Lecture seule du reste du site : aucun prix, aucune valeur, aucune
 * automatisation de couleur/gravure/prix n'est touchee ou modifiee ici.
 */
(function () {
  var CART_ENDPOINT_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var refreshTimer = null;

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshShippingProgress, 80);
  }

  function refreshShippingProgress() {
    if (!document.querySelector('.free-shipping-progress')) return;
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.free-shipping-progress');
        if (!fresh) return;
        document.querySelectorAll('.free-shipping-progress').forEach(function (el) {
          el.outerHTML = fresh.outerHTML;
        });
      })
      .catch(function () {});
  }

  // --- Interception fetch() ---
  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartMutation = CART_ENDPOINT_RE.test(url);
      var result = originalFetch.apply(this, arguments);
      if (isCartMutation) {
        result.then(scheduleRefresh).catch(function () {});
      }
      return result;
    };
  }

  // --- Interception XMLHttpRequest (au cas ou une app tierce l'utilise plutot que fetch) ---
  var OriginalXHR = window.XMLHttpRequest;
  if (OriginalXHR) {
    var originalOpen = OriginalXHR.prototype.open;
    OriginalXHR.prototype.open = function (method, url) {
      this.__msIsCartMutation = typeof url === 'string' && CART_ENDPOINT_RE.test(url);
      return originalOpen.apply(this, arguments);
    };
    var originalSend = OriginalXHR.prototype.send;
    OriginalXHR.prototype.send = function () {
      if (this.__msIsCartMutation) {
        this.addEventListener('loadend', scheduleRefresh);
      }
      return originalSend.apply(this, arguments);
    };
  }

  // --- Filet de securite : evenement interne de mise a jour du panier du theme ---
  function subscribeToCartUpdate() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
      return true;
    }
    return false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', subscribeToCartUpdate);
  } else {
    subscribeToCartUpdate();
  }
})();